import { render, staticRenderFns } from "./AlunoEnderecoForm.vue?vue&type=template&id=62c2fd09&"
import script from "./AlunoEnderecoForm.vue?vue&type=script&lang=js&"
export * from "./AlunoEnderecoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports